module.exports = __webpack_public_path__ + "assets/imgs/achs/gPartner.0ae6674b95cd66573a2d4cac071178eb.png";